export default __webpack_public_path__ + "static/media/logout-hover.2e408394.svg";